import React from "react";
import { Link, useNavigate } from "react-router-dom";
import useCartStore from "../Stores/CartStore"; // تأكد من المسار الصحيح

const CartPage = () => {
  const { items, removeItemAtIndex, clearCart } = useCartStore((state) => ({
    items: state.items,
    removeItemAtIndex: state.removeItemAtIndex,
    clearCart: state.clearCart,
  }));

  const navigate = useNavigate();

  const handleCheckout = () => {
    if (items.length === 0) {
      alert("السلة فارغة");
      return;
    }
    navigate("/checkout");
  };



  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6 text-center">سلة التسوق</h1>
      {items.length === 0 ? (
        <p className="text-center text-white bg-blue-400 p-5 text-lg rounded ">السلة فارغة <Link to='/' className="underline  mr-1 cursor-pointer" >اضف منتجات</Link></p>
      ) : (
        <div>
          <ul className="space-y-6">
            {items.map((item, index) => (
              <li
                key={index}
                className="p-6 border border-gray-300 rounded-lg shadow-md bg-white"
              >
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <h2 className="text-xl font-semibold mb-2 text-gray-800">
                      {item.productName}
                    </h2>
                    <p className="font-bold mb-2 text-gray-700">
                      العرض: {item.quantity} قطعة بـ {item.price} جنيه
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                      {item.options.map((option, optionIndex) => (
                        <div
                          key={optionIndex}
                          className="p-4 border border-gray-200 rounded-lg bg-gray-50"
                        >
                          <p className="font-semibold">
                            القطعة {optionIndex + 1}:
                          </p>
                          <p>اللون: {option.color.label || "غير محدد"}</p>
                          <p>المقاس: {option.size.label || "غير محدد"}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                  <button
                    onClick={() => removeItemAtIndex(index)}
                    className="ml-4 text-red-600 hover:text-red-800 font-semibold"
                  >
                    حذف
                  </button>
                </div>
              </li>
            ))}
          </ul>
          <div className="mt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
            <button
              onClick={handleCheckout}
              className="w-full sm:w-auto p-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition"
            >
              إتمام الطلب
            </button>
            <button
              onClick={clearCart}
              className="w-full sm:w-auto p-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
            >
              مسح السلة
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartPage;
